import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll the window to the top on every route change.
 *
 * React Router keeps the scroll offset across navigations, so following a link
 * from halfway down a long page (the dashboard, a persona list) landed the next
 * page mid-content with its header off-screen.
 *
 * Keyed on `pathname` only, NOT on `search`: several pages keep UI state in the
 * query string (the Conversations view tab, filter params), and scrolling to the
 * top every time a filter changes would yank the page out from under the user.
 *
 * A `hash` short-circuits it — `/geo-strategy#cibles` exists precisely to land on
 * an element, and the browser's own anchor scroll must win.
 *
 * `DashboardLayout` has no inner scroll container (`minHeight: 100vh`, no
 * `overflow`), so the window is the thing that scrolls.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
